<dx-autocomplete
  placeholder="Global Search..."
  class="search-width"
  [dataSource]="datasource"
  itemTemplate="searchItem"
  valueExpr="name"
  [grouped]="true"
  groupTemplate="groupTemplate"
  [searchTimeout]="1000"
  #giacomo
  (onEnterKey)="onKeyDown($event, giacomo)"
>
  <div *dxTemplate="let data of 'groupTemplate'" class="group_header">
    <div>Group: {{ data.key }}</div>
    <div class="clickable" (click)="showAllResultOfType(data.key, giacomo)">
      Total: {{ data.count }}
    </div>
  </div>
  <div
    *dxTemplate="let item of 'searchItem'"
    class="autocomplete_list_item"
    (click)="redirectToSelectedItem(item, giacomo)"
  >
    <span class="material-symbols-outlined margin-right">
      @switch (item.type) {
        @case ("Resource") {
          attribution
        }
        @case ("Opportunity") {
          draft
        }
        @case ("Workload") {
          draft
        }
        @case ("Proposal") {
          description
        }
        @case ("Contract") {
          request_quote
        }
        @default {
          description
        }
      }
    </span>
    @if (item.type === "Resource") {
      <div class="autocomplete_list_item_layout">
        <div class="autocomplete_list_item_text">
          <span class="max-width"
            ><strong>Employee</strong>: {{ item.name }} {{ item.surname }}</span
          >
          <span class="max-width"><strong>Role</strong>: {{ item.role }}</span>
        </div>
        <div class="autocomplete_list_item_text">
          <span class="max-width"
            ><strong>Country</strong>: {{ item.country }}</span
          >
        </div>
      </div>
    } @else {
      <div class="autocomplete_list_item_layout">
        <div class="autocomplete_list_item_text">
          <span><strong>Code</strong>: {{ item.code }}</span>
        </div>
        <div class="autocomplete_list_item_text">
          <span class="max-width">
            <strong>Name</strong>:
            {{ item.name }}
          </span>
          <span class="max-width">
            <strong>Customer</strong>:
            {{ item.customer }}
          </span>
        </div>
      </div>
    }
  </div>
</dx-autocomplete>

<app-results-modal
  [(isPopupVisible)]="isPopupVisible"
  [records]="results"
  [researchType]="searchType"
  [searchTerm]="searchQuery"
></app-results-modal>
